import { render, staticRenderFns } from "./BankAccountsForm.vue?vue&type=template&id=86b14206"
import script from "./BankAccountsForm.vue?vue&type=script&lang=js"
export * from "./BankAccountsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports